import Breadcrumb from "../../Component/Breadcrumb";

function AcademicReg() {
  return (
    <>
      <Breadcrumb>Students / Academic Year & Registration</Breadcrumb>
      <div className="innersec">
        <div className="container">
          <div className="col-lg-12">
            <h1>Admission Guidelines</h1>
          </div>
          <div className="admission-section ">
            {/* === GENERAL ADMISSION RULES === */}
            <div className="admission-card mb-5">
              <h3 className="admission-heading">- General Admission Rules</h3>
              <ol className="admission-list">
                <li>
                  The academic year of the school is from April to March..
                </li>
                <li>
                  Admission to classes Playway, lower K.G. and upper K.G. are
                  taken in February - March.
                </li>
                <li>
                  Application to other classes will be entertained only at the
                  instance of vacancies in those classes.
                </li>
                <li>
                  The prospectus with Application form shall be available from
                  school office during the prescribed date and hours.
                </li>
                <li>
                  Interaction with the child and written text for admission
                  shall be taken on the date informed.
                </li>
                <li>Date of Birth shall not be changed at any stage later.</li>
                <li>
                  Medical fitness certificate (proforma will be given from the
                  school).
                </li>
                <li>
                  Registration form will be issued in the name of the child and
                  its non-transferable
                </li>
                <li>Registration fee is not refundable.</li>
              </ol>

              <div className="admission-note">
                <strong>Note:</strong>Note: Registration does not guarantee
                admission. It will be subjected to merit & availability of the
                seat.
              </div>
            </div>

            {/* === PLAYWAY === */}
            <div className="admission-card mb-5">
              <h3 className="admission-heading">
                REQUIREMENTS AND ELIGIBILITY FOR ADMISSION IN PLAYWAY.
              </h3>
              <ol className="admission-list">
                <li>
                  A child who has completed three years on March 31st of the
                  year of admission.
                </li>
                <li>
                  Stamp-size photographs of the child, Father & Mother to be
                  affixed on the Application form
                </li>
                <li>
                  Birth Certificate from the competent authority, such as:
                  Panchayat / Nagarpalika.
                </li>
              </ol>
            </div>

            {/* === LKG & UKG === */}
            <div className="admission-card mb-5">
              <h3 className="admission-heading">
                REQUIREMENTS AND ELIGIBILITY FOR ADMISSION - CLASS LKG & UKG
              </h3>
              <ol className="admission-list">
                <li>
                  Interview and Written Test will be taken in English,
                  Mathematics, and Hindi. 50% marks is compulsory in each
                  subject to qualify for the admission.
                </li>
                <li>
                  A Child who had completed 4 years (LKG) & Five Years (UKG) as
                  on 31st March of the admission year.
                </li>
                <li>
                  Stamp-size photographs of the child, Father & Mother to be
                  affixed on the Application form
                </li>
                <li>
                  Birth Certificates/ TC, Marksheet & PEN number from the school
                  last attended.
                </li>
              </ol>
            </div>

            {/* === CLASS I TO IX === */}
            <div className="admission-card mb-5">
              <h3 className="admission-heading">
                REQUIREMENTS AND ELIGIBILITY FOR ADMISSION FOR CLASS I TO IX
              </h3>
              <ol className="admission-list">
                <li>
                  Admission to class I to IX will be entertained only at the
                  instance of vacancies in those classes.
                </li>
                <li>
                  Written Test will be taken in{" "}
                  <strong>
                    English, Mathematics, Hindi, Science & Social Science.
                  </strong>{" "}
                  70% marks is compulsory in each subject to qualify for the
                  admission.
                </li>
                <li>
                  Transfer Certificate, Mark Sheet, and{" "}
                  <strong>PEN number</strong> from the last attended
                </li>
              </ol>
            </div>

            {/* === CLASS XI === */}
            <div className="admission-card mb-5">
              <h3 className="admission-heading">
                REQUIREMENTS AND ELIGIBILITY FOR ADMISSION FOR XI
              </h3>
              <p className="intro-text">
                The school offers <strong>three streams</strong> for Higher
                Secondary students:
              </p>
              <ul className="stream-list">
                <li>
                  <strong>Science (Mathematics)</strong> — Hindi Core/Computer
                  Science, English Core, Mathematics, Physics, Chemistry
                </li>
                <li>
                  <strong>Science (Biology)</strong> — Hindi Core/Computer
                  Science, English Core, Biology, Physics, Chemistry
                </li>
                <li>
                  <strong>Commerce</strong> — Hindi Core/Computer Science,
                  English Core, Accountancy, Business Studies, Economics.
                </li>
              </ul>

              <div className="admission-note">
                <strong>Note:</strong> Group will be decided based on the Marks
                scored by the candidates in the subjects in the pre-Board Exams
                conducted by the school.
              </div>

              <p className="admission-footer">
                Admission of the students from outside will be considered only
                in the case of vacancy i.e. after considering the students from
                this institution. Out side students have to score{" "}
                <strong>75%</strong> of Marks in the subjects they apply for.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default AcademicReg;
